import { RealEstate } from '../../../../@types/real-estate-api-types'
import { ContentStateInterface, EstateFeatures } from '../../../../@types/types'

export const estateFeaturesToApp = (
  listing: RealEstate,
  defaultStateValues: ContentStateInterface
): EstateFeatures => ({
  basement: listing.details?.basement ?? defaultStateValues.estateFeatures?.basement,
  hasCanteen: listing.details?.hasCanteen ?? defaultStateValues.estateFeatures?.hasCanteen,
  handicappedAccessible:
    listing.details?.handicappedAccessible ?? defaultStateValues.estateFeatures?.handicappedAccessible,
  highVoltage: listing.details?.highVoltage ?? defaultStateValues.estateFeatures?.highVoltage,
  elevator: listing.details?.elevator ?? defaultStateValues.estateFeatures?.elevator,
  kitchenComplete: listing.details?.kitchenComplete ?? defaultStateValues.estateFeatures?.kitchenComplete,
  ramp: listing.details?.ramp ?? defaultStateValues.estateFeatures?.ramp,
  liftingPlatform: listing.details?.liftingPlatform ?? defaultStateValues.estateFeatures?.liftingPlatform,
  balconyTerrace: listing.details?.balconyTerrace ?? defaultStateValues.estateFeatures?.balconyTerrace,
  certificateOfEligibilityNeeded:
    listing.details?.certificateOfEligibilityNeeded ??
    defaultStateValues.estateFeatures?.certificateOfEligibilityNeeded,
  equippedKitchen: listing.details?.equippedKitchen ?? defaultStateValues.estateFeatures?.equippedKitchen,
  flatShareSuitable: listing.details?.flatShareSuitable ?? defaultStateValues.estateFeatures?.flatShareSuitable,
  guestToilet: listing.details?.guestToilet ?? defaultStateValues.estateFeatures?.guestToilet,
  sharedGarden: listing.details?.sharedGarden ?? defaultStateValues.estateFeatures?.sharedGarden,
  dishwasher: listing.details?.dishwasher ?? defaultStateValues.estateFeatures?.dishwasher,
  washingMachine: listing.details?.washingMachine ?? defaultStateValues.estateFeatures?.washingMachine,
  bathHasWc: listing.details?.bathHasWc ?? defaultStateValues.estateFeatures?.bathHasWc,
  bathHasShower: listing.details?.bathHasShower ?? defaultStateValues.estateFeatures?.bathHasShower,
  bathHasTub: listing.details?.bathHasTub ?? defaultStateValues.estateFeatures?.bathHasTub,
  internet: listing.details?.internet ?? defaultStateValues.estateFeatures?.internet,
  tv: listing.details?.tv ?? defaultStateValues.estateFeatures?.tv,
  summerResidencePractical:
    listing.details?.summerResidencePractical ?? defaultStateValues.estateFeatures?.summerResidencePractical,
  lodgerFlat: listing.details?.lodgerFlat ?? defaultStateValues.estateFeatures?.lodgerFlat,
  monument: listing.details?.monument ?? defaultStateValues.estateFeatures?.monument,
  listed: listing.details?.listed ?? defaultStateValues.estateFeatures?.listed,
  nonSmoker: listing.details?.nonSmoker ?? defaultStateValues.estateFeatures?.nonSmoker,
  terrace: listing.details?.terrace ?? defaultStateValues.estateFeatures?.terrace,
  shortTermConstructible:
    listing.details?.shortTermConstructible ?? defaultStateValues.estateFeatures?.shortTermConstructible,
  buildingPermission: listing.details?.buildingPermission ?? defaultStateValues.estateFeatures?.buildingPermission,
  demolition: listing.details?.demolition ?? defaultStateValues.estateFeatures?.demolition,
})
